/* src/app/dropdown/dropdown.component.scss */
.dropdown {
  width: 100%;
  -webkit-user-select: none;
  user-select: none;
}
.dropdown .empty {
  color: #888;
  opacity: 1;
  font-family: inherit;
  font-size: inherit;
  font-weight: normal;
}
.dropdown .selector {
  border-radius: 30px;
  background: white;
  color: black;
  padding: 5px 20px;
  text-align: left;
  font-size: 1.5rem;
  position: relative;
}
.dropdown .selector .arrow {
  position: absolute;
  right: 30px;
  top: 6px;
  background-image: url(/assets/img/arrow_down.png);
  width: 30px;
  height: 30px;
}
.dropdown .selector.have-value {
  font-weight: bold;
  font-style: normal;
}
.dropdown .options {
  background: #f7f7f7;
  color: black;
  position: absolute;
  max-height: 440px;
  overflow-y: auto;
  width: 100%;
  border-radius: 20px;
  margin-top: 5px;
}
.dropdown .options .option {
  text-align: left;
  font-size: 1.5rem;
  line-height: 1.5rem;
  padding: 5px 20px;
}
.dropdown .options .option:hover {
  background: #CCCCCC;
}
/*# sourceMappingURL=dropdown.component.css.map */
